export default {
	BOX: 'box',
    DUSTBIN_BOX: 'dustbinBox'
}



// WEBPACK FOOTER //
// ./src/components/drag/constants/ItemTypes.js